import {  useState } from "react";
import Navbar from "../../components/fragments/navbar";
import BacaQuran from "../baca_quran";
import Bookmark from "../bookmark";
import Beranda from "../Beranda";

function Layouts() {
  const menus = [
    {
      name: "Beranda",
      page: <Beranda/>,
    },
    // {
    //   name: "Tentang Kami",
    //   page: <></>,
    // },
    {
      name: "Baca Al-Quran",
      page: <BacaQuran />,
    },
    // {
    //   name: "Jadwal Sholat",
    //   page: <Bookmark />,
    // },
    {
      name: "Bookmark",
      page: <Bookmark />,
    },
  ];
  const [selectedPage, setSelectedPage] = useState(menus[0]);


  function onHandleClickMenu(menu) {
    setSelectedPage(menu);
  }

  return (
    <div className="h-screen w-full flex flex-col">
      {/* Navbar */}
      <Navbar menus={menus} onHandleClickMenu={onHandleClickMenu} selectedPage={selectedPage} />

      {/* Content */}
      <div className="w-full h-full">{selectedPage.page}</div>
    </div>
  );
}

export default Layouts;
